import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.gray900};
  align-items: center;
`;

export const TopContainer = styled.div`
  display: flex;
  gap: 8px;
  position: fixed;
  align-items: center;
  justify-content: space-between;
  left: 0;
  top: 42px;
  margin: 10px 24px;
  right: 0;
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.gray800};
  border: none;
  border-radius: 8px;
  font-size: 20px;
`;

export const Image = styled.img`
  width: 100vw;
  height: 70vw;
  object-fit: cover;
`;

export const ImageDefault = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  color: white;
`;

export const ImageContainer = styled.div`
  width: 100vw;
  height: 75vw;
  background-color: ${({ theme }) => theme.colors.gray800};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100vw;
    height: 75vw;
    object-fit: contain;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 24px 16px 0 16px;
`;

export const Label = styled.label`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray25};
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.03);
  padding: 8px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 8px;
`;
